<div [height]="20">    
</div>
<div class="txt" data-testid="Subscription-cancel-text" i18n>

    {{ 'CANCELLING_WILL_STOP_YOUR' | translate }}<br />
    {{ 'CURRENT_BILLING_CYCLE_AT' | translate }} <br />
    {{ 'YOUR_SUBSCRIPTION_ONLY_FEATURES' | translate }}.<br /><br /><br />
    {{ 'ARE_YOU_SURE_YOU_WANT_TO_CONTINUE' | translate }}?


</div>
<div [height]="15">
</div>
<div class="cnt-row" style="justify-content: center">
    <div class="line"></div>
</div>
<div [height]="15">
</div>
<div class="cnt-row" style="justify-content: center">
    
    <simple-btn [width]="200" 
         [text]="'CANCEL_SUBSCRIPTION' | translate"
         i18n-text
         (click)="onCancel()" 
         [textCls]="'large-btn-text'"
         [height]="40"
         [cornerRadius]="50" 
         [horizontalPadding]="20" 
         [backgroundFillCls]="'transparent-background'"
         [hoverFillCls]="'g4Background'"
         [borderWidth]=2
         [borderColorCls]="'g4Border'"
         [hoverBorderColorCls]="'g4Border'"
         [textColorCls]="'g4Color'"
         [hoverTextColorCls]="'white-color'"
         data-testid="Subscription-cancel-cancel-btn">

    </simple-btn>

    <div [width]="20"></div>

    <simple-btn  [width]="200" 
             [text]="'KEEP_SUBSCRIPTION' | translate"
             i18n-text
             [backgroundFillCls]="'o2Background'"
             [hoverFillCls]="'o1Background'"
             [boxShadowCls]="'primary-shadow'"
             (click)="onKeep()" 
             [textCls]="'large-btn-text'"
             [height]="40"
             [cornerRadius]="50" 
             [horizontalPadding]="20"
             data-testid="Subscription-cancel-keep-btn">

    </simple-btn>
        
</div>